import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AuthUtil from '../components/Utils/AuthUtil';

export default function Authorized (props) {
    const navigate = useNavigate();

    const userToken = useSelector((state) => state.correcttrack.userToken);
    // adminOnly pages are for super admins and organization admins; the server enforces the same.
    const isAuthorized = useMemo(
        () => AuthUtil.isAuthorized(userToken)
            && (!props.adminOnly || AuthUtil.isSuperAdmin(userToken) || AuthUtil.isAdmin(userToken)),
        [userToken, props.adminOnly],
    );

    useEffect(() => {
        if(!isAuthorized) {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isAuthorized && props.authorized}
        </>
    );
}

Authorized.propTypes = {
    authorized: PropTypes.element.isRequired,
    adminOnly: PropTypes.bool,
};
